import React, {useEffect, useState} from "react";
import styles from "../../styles/create_styles.module.scss";
import {ReactComponent as Arrow} from "../../assets/icons/arrow-left.svg";

import {useParams} from "react-router-dom";
import {useMutation, useQuery} from "react-query";
import {getCategory, storeCategory} from "../../services/services";
import {toast} from "react-toastify";
import {Form, Formik} from "formik";
import {BarLoader} from "react-spinners";
import Button from "../../components/Button/Button";
import {queryClient} from "../../services/queryClient";
import {IGetCategory, IPostCategory} from "../../ts/interfaces/Category/interface";


const CreateCategory: React.FC = () => {
    const queryParams = useParams();

    document.title = 'Admin - ' + (queryParams?.id ? 'Editar' : 'Cadastrar') + ' categoria';

    const stylesSelect = {
        control: (styles: any) => ({
            ...styles,
            width: "100%",
            height: "37px",
        }),
        indicatorsContainer: (styles: any) => ({
            ...styles,
            height: "37px",
        }),
        valueContainer: (styles: any) => ({
            ...styles,
            height: "37px",
            display: "flex",
            alignItems: "center",
            padding: "0px 8px",
            "overflow-y": "auto"
        }),
        dropdownIndicator: (styles: any) => ({
            ...styles,
            padding: "4px",
        }),
        clearIndicator: (styles: any) => ({
            ...styles,
            padding: "4px",
        }),
    };

    const {data, isLoading, refetch} = useQuery<{
        data: IGetCategory;
        status: number
    }>(
        ["category", queryParams?.id],
        () => getCategory(parseInt(queryParams?.id ?? "0")),
        {

            staleTime: Infinity,
            enabled: !!queryParams?.id,
        }
    );

    if (!isLoading && queryParams?.id && data?.status !== 200) {
        window.location.href = '/categories';
    }

    const [params, setParams] = useState<IPostCategory>({
        id: null,
        name: "",
    });

    useEffect(() => {
        if (data && data.data) {
            setParams({
                ...params,
                id: data.data.id,
                name: data.data.name,
            });
        }
    }, [data]);

    useEffect(() => {
        refetch()
    }, []);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>) => {
        setParams({...params, [e.target.name]: e.target.value});
    };

    const onSubmit = () => {
        if (!params.name || params.name.trim() === "") {
            toast.error("Preencha o nome.");
            return;
        }

        const formData = new FormData();

        formData.append("id", params.id ? params.id.toString() : "");
        formData.append("name", params.name ?? "");

        mutate.mutate(formData);
    };

    const mutate = useMutation(
        (data: FormData) => {
            return storeCategory(data);
        },
        {
            onSettled: (response) => {
                if (response?.data?.success) {
                    toast.success("Salvo com sucesso!");
                    queryClient.invalidateQueries(['filter-categories'])

                    setTimeout(() => {
                        window.location.href = "/categories";
                    }, 800);
                } else {
                    toast.error("Erro ao salvar categoria. " + (response?.data?.msg ?? ''));
                }
            },
            onError: (error) => {
                toast.error("Erro ao salvar categoria");
            },
        }
    );

    return (
        <>
            <Formik
                initialValues={{
                    name: "",
                    sku: "",
                    url: "",
                }}
                onSubmit={() => onSubmit()}
            >
                <Form className={styles.container}>
                    <div className={styles.content}>
                        <div className={styles.title}>
                            <a
                                href="/categories"
                                className={styles.btnReturn}
                            >
                                <Arrow/> Voltar
                            </a>
                            <h1>
                                {params.id ? "Editar" : "Cadastrar"} Categoria
                            </h1>
                        </div>
                        {isLoading ? (
                            <div className={styles.alignCenter}>
                                <span>Carregando</span>
                                <BarLoader
                                    color={"#ff7526"}
                                    loading={isLoading}
                                    aria-label="Loading Spinner"
                                    data-testid="loader"
                                />
                            </div>
                        ) : (
                            <>
                                <div className={styles.box}>
                                    <p className={styles.boxTitle}>
                                        Informe os dados da categoria {queryParams?.id}
                                    </p>
                                    <div className={styles.groupData}>
                                        <div>
                                            <div className={styles.groupInput}>
                                                <label htmlFor="name">
                                                    Nome
                                                </label>
                                                <input
                                                    disabled={mutate.isLoading}
                                                    value={params.name}
                                                    onChange={(e) =>
                                                        handleChange(e)
                                                    }
                                                    className={styles.input}
                                                    type="text"
                                                    name="name"
                                                    id="name"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.box}>
                                    <div className={styles.alignButtons}>
                                        <Button
                                            disabled={mutate.isLoading}
                                            width="175px"
                                            height="50px"
                                            type="submit"
                                        >
                                            Salvar
                                        </Button>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </Form>
            </Formik>
        </>
    );
};

export default CreateCategory;
